import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { LwField, LwStatusPill } from '@/components/lw';
import { recruitStatusBadge } from './recruitStatusPill';
import type { RecruitmentFormValues } from './validations';

interface StatusSectionProps {
  form: UseFormReturn<RecruitmentFormValues>;
}

export const StatusSection: React.FC<StatusSectionProps> = ({ form }) => {
  const { register, formState: { errors }, watch } = form;

  const currentStatus = watch('status');
  const statusComment = watch('statusComment');

  return (
    <div>
      <div className="dw-sec-title">Application status</div>
      <div className="dw-grid">
        <LwField label="Current status" readonly hint="Updated automatically from contract & onboarding progress">
          {currentStatus ? (
            <LwStatusPill {...recruitStatusBadge(currentStatus)} />
          ) : (
            <span className="adv-empty">No status set</span>
          )}
        </LwField>

        <LwField
          span="full"
          label="Status comment"
          htmlFor="statusComment"
          error={errors.statusComment?.message}
          hint={`${statusComment?.length || 0} / 500 · added to the candidate's history`}
        >
          <textarea
            id="statusComment"
            className={errors.statusComment ? 'invalid' : ''}
            {...register('statusComment')}
            placeholder="Add context for this status (optional)…"
            maxLength={500}
          />
        </LwField>
      </div>
    </div>
  );
};
